import { render, staticRenderFns } from "./CaregiverCard.vue?vue&type=template&id=47d77a52&scoped=true"
import script from "./CaregiverCard.vue?vue&type=script&lang=js"
export * from "./CaregiverCard.vue?vue&type=script&lang=js"
import style0 from "./CaregiverCard.vue?vue&type=style&index=0&id=47d77a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d77a52",
  null
  
)

export default component.exports